module.exports = {
      id: "saque-indisponivel-usage",
      viewBox: "0 0 117 129",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#saque-indisponivel",
      toString: function () {
        return this.url;
      }
    }